import Vue from 'vue'
import Router from 'vue-router'
import dropdown from '@/components/dropdown'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import axios from "axios";
Vue.component('v-select', vSelect)
Vue.use(Router)

export default new Router({
  routes: [
    {
      path : '/dropdown',
      name : 'dropdown',
      component : dropdown,
      props : true
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js